"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HeaderNavigation_1 = __importDefault(require("./HeaderNavigation"));
exports.default = HeaderNavigation_1.default;
